<template>
    <div class="modal fade " id="withdrawalPassword" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('forgot-withdraw-password','Forgot Withdraw Password') }}</h5>
                    <button @click="$helper.closeModal('withdrawalPassword');resetWithdrawForm()" type="button" class="btn-close"></button>
                </div>
                <div class="modal-body">
                    <div class="cmn-form">
                        <div class="cmn-form-group">
                            <label for="exampleInputEmail1" class="form-label">{{$t('enter-withdrawal-otp','Enter Withdrawal OTP')}} <span class="sent-top-no-info">({{$t('otp-sent-to','sent to ')}}****** {{ $auth?.user?.phone?.slice(-4) }})</span></label>
                            <div  class="withdraw-instruction">
                                <h4 >Withdraw Instruction</h4>
                                <ul class="instruction-list">
                                    <li>{{ $t('withdraw-password-eight-twenty', 'Withdraw Password Must be of minimum 8 characters and maximum 20 characters required') }}</li>
                                    <li>{{ $t('withdraw-password-small-capital', 'Withdraw Password Must have atleast 1 small and 1 capital alphabet') }}</li>
                                    <li>{{ $t('withdraw-password-digit-special-char', 'Withdraw Password Must have atleast 1 Digit and 1 Special character') }}</li>
                                    <li>{{ $t('please-take-note-your-withdraw-password', 'Please take a note of your Withdraw Password') }}</li>
                                </ul>
                            </div> 
                            <div class="opt_send">
                                <input type="tel" v-model="withdraw.otp"  maxlength="6" :placeholder="$t('enter-otp','Enter OTP')+'*'" class="form-control"
                                    :class="isOtpApiCalled && init.otp && checkValidation?.otp?.length > 0 ? 'border border-1 border-danger': ''" 
                                    @input="withdraw.otp = $helper.sanitizeNumber(withdraw.otp, 999999); validate() " /> 
                                    <div class="otp-btn-timer">
                                    <!-- <span class="otpExpire-text" v-if="minutes > 0 || seconds > 0">OTP Expire In {{ minutes }}:{{ seconds }}</span> -->
                                        <span class="otpExpire-text" v-if="minutes > 0 || seconds > 0"> {{ minutes }}:{{ seconds }}</span>
                                        <button v-if="isResentOtpBtnVisiable" @click="resendOtp()" :disabled="loading" class="btn resend-otp-link re_btn">{{$t('resend','Resend')}}</button>
                                    </div>   
                                    <div class="d-flex justify-content-end">
                                        <div class="initMobile-error">
                                            <!-- errors -->
                                            <template v-if="isOtpApiCalled && init.otp && checkValidation?.otp?.length > 0">
                                                <template v-for="(err, index) in checkValidation?.otp" :key="index">
                                                    <p class="text-danger error-msg  mt-1"> {{ $t(err.lang, err.error) }}</p>
                                                </template>
                                            </template>
                                        </div>
                                    </div>
                            </div>
                        </div>
                        <div class="cmn-form-group cmn-form-password">
                            <!-- <label for="exampleInputEmail1" class="form-label">Withdrawal Password</label>  -->
                             <input v-model="withdraw.password" :type="oldPasswordFieldType" :placeholder="$t('enter-withdraw-password', 'Enter Withdraw Password')+'*'" class="form-control"
                                    @input="withdraw.password = $helper.sanitizeDetails('withdrawPassword', withdraw.password, 20); validate()" 
                                    :class="isOtpApiCalled && init.password && checkValidation?.withdrawPassword?.length > 0 ? 'border border-1 border-danger' : ''" />
                            <div class="score-hide-show" @click="togglePasswordVisibility('oldPassword')">
                                <img class="score-hide-icon" loading="lazy" :src="oldPasswordFieldType  === 'password' ? require('@/assets/images/score-hide-icon.svg')  : require('@/assets/images/score-visible.svg')" alt="">
                            </div>                              
                            <!-- errors -->
                            <template v-if="isOtpApiCalled && init.password && checkValidation?.withdrawPassword?.length > 0">
                                <template v-for="(err, index) in checkValidation?.withdrawPassword" :key="index">
                                    <p class="text-danger error-msg">&#x2022; {{ $t(err.lang, err.error) }}</p>
                                </template>
                            </template>
                        </div>
                        <div class="cmn-form-group cmn-form-password">
                            <!-- <label for="exampleInputEmail1" class="form-label">Withdrawal Confirm Password</label>  -->
                             <input v-model="withdraw.c_password" :type="newPasswordFieldType" :placeholder="$t('enter-confirm-withdraw-password', 'Enter Confirm Withdraw Password')+'*'" class="form-control"
                                    @input="withdraw.c_password = $helper.sanitizeDetails('withdrawPassword', withdraw.c_password, 20); validate()" 
                                    :class="isOtpApiCalled && init.confirmPassword && checkValidation?.confirmPassword?.length > 0 ? 'border border-1 border-danger' : ''" /> 
                            <div class="score-hide-show" @click="togglePasswordVisibility('newPassword')">
                                <img class="score-hide-icon" loading="lazy" :src="newPasswordFieldType === 'password' ? require('@/assets/images/score-hide-icon.svg') :  require('@/assets/images/score-visible.svg')" alt="">
                            </div>                      
                            <!-- errors -->
                            <template v-if="isOtpApiCalled && init.c_password && checkValidation?.confirmWithdrawPassword?.length > 0">
                                <template v-for="(err, index) in checkValidation?.confirmWithdrawPassword" :key="index">
                                    <p class="text-danger error-msg">&#x2022; {{ $t(err.lang, err.error) }}</p>
                                </template>
                            </template>
                        </div>
                            
                        <div class="add-acc-model-footer">
                            <button @click="validateOtp()" type="button" class="btn thm-but">Submit</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import validate from '@/modules/authorization/services/WithdrawValidation';
import {resetWithdrawalPassword, openWithdrawPasswordModal, startWithdrawTimer} from "../services/withdrawAccountDetails"
export default{
   name:'WithdrawalPasswordSetReset',
    emits:['openWithdrawPasswordModal'],
    data(){
        return{
            withdraw : {
                phone : '',
                otp : '',
                password : '',
                c_password : '',
            },
            isResentOtpBtnVisiable : false,
            startTime: null,
            endTime: null,
            timeLeft: 0,
            timer: null,
            validationErrors : null,
            init:{
                otp:false,
                c_password:false,
                password:false
            },
            isOtpApiCalled:false,
            oldPasswordFieldType : 'password',
            newPasswordFieldType: 'password',
            loading: false
        }
    },
    computed:{
         minutes() {
            return Math.floor(this.timeLeft / 60).toString().padStart(2, '0');
        },
        seconds() {
            return (this.timeLeft % 60).toString().padStart(2, '0');
        },
        checkValidation() {
			return this.validationErrors;
		}
    },
    methods:{
        togglePasswordVisibility(fieldName) {
            if(fieldName == 'oldPassword'){
                this.oldPasswordFieldType = this.oldPasswordFieldType === 'password' ? 'text' : 'password';
            } else{
                this.newPasswordFieldType = this.newPasswordFieldType === 'password' ? 'text' : 'password';
            }
        },
        toggleInit(bool){
            this.init={
                otp:bool,
                c_password:bool,
                password:bool
            }
        },
        validate(){
            this.validationErrors = validate.areFieldsValid(
                'withdraw-password',
				this.withdraw.otp, 
				this.withdraw.password,
				this.withdraw.c_password,
            );
            return this.validationErrors;                                                                                                    
        },
        async resetWithdrawForm(){
            this.oldPasswordFieldType = 'password';
            this.newPasswordFieldType = 'password',
            this.withdraw ={
                phone: '',
                otp: '',
                password: '',
                c_password: ''
            },
            this.isOtpApiCalled = false;
            this.validationErrors = null;
            this.toggleInit(false)
        },
        async resendOtp(){
            this.loading = true
            try {
                let response = await openWithdrawPasswordModal()
                this.loading = false
                if(!response?.error){
                    this.resetTimer()
                }
            } catch (error) {
                this.loading = false
                this.$errorToast(error);
            }
        },
        async startTimer() {
            startWithdrawTimer((data) => {
                this.isResentOtpBtnVisiable = data.isResentOtpBtnVisiable;
                this.timeLeft = data.timeLeft;
                this.timer = data.timer;
            });
        },
        stopTimer() {
            this.isResentOtpBtnVisiable = false;
            clearInterval(this.timer);
        },
        resetTimer() {
            this.isResentOtpBtnVisiable = false;
            clearInterval(this.timer);
            this.startTime = null;
            this.endTime = null;
            this.timeLeft = 5 * 60;
            this.startTimer();
        },
        async validateOtp() {
            this.toggleInit(true);
            if (Object.keys(this.validate())?.filter(key => !['newPassword', 'newUserId'].includes(key))?.length !== 0) return;
            const resetResponse = await this.resetWithdrawalPassword()

            if (resetResponse.error) {
                this.$errorToast(resetResponse?.error);
                if(resetResponse?.error?.[0]?.includes('OTP Expired')){
                    this.isResentOtpBtnVisiable = true;
                    clearInterval(this.timer);
                    this.timeLeft = 0;
                }
                return;
            }
            else {
                await this.resetWithdrawForm();
                this.$helper.closeModal('withdrawalPassword');
                this.resetTimer();
                // this.$successToast(resetResponse?.message);
            }
        },
        async resetWithdrawalPassword(){
            if (!this.withdraw.password || this.withdraw.password == null) {
                this.$errorToast("New WithDraw Password Required!");
                return; 
            }
            if (this.withdraw.password != this.withdraw.c_password) {
                this.$errorToast("Confirm WithDraw Password Does Not Match With New WithDraw Password");
                return;
            }
            let data = {
                otp: this.withdraw.otp,
                password: this.withdraw.password,
            }
            console.log(data)

            let response = await resetWithdrawalPassword(data)
            if(response?.error) return {error : response.error}
            else return true
        },
        otpHasBeenCalled(){
            this.isOtpApiCalled = true;
        },
        assignWithdrawPhoneNumber(number){
            this.withdraw.phone = number
        }
    }
}
</script>
<style scoped>

</style>